jQuery(document).ready(function ($) {

	$('.search-button').click(function () {
		$('.header.sticky-container').toggleClass('has-transition-push');
	});
	$('.js-off-canvas-overlay').click(function () {
		$('.header.sticky-container').removeClass('has-transition-push');
	});

	$('a[data-toggle="off-canvas"]').click(function () {
		$('.header.sticky-container').addClass('has-transition-push-left');  // fix for normal hamburger menu
	});

	$('.js-off-canvas-overlay').click(function () {
		$('.header.sticky-container').removeClass('has-transition-push-left');
	});

	$('#offCanvasTop').on('opened.zf.offcanvas', function (event) {

		setTimeout(
			function () {
				$('#search-label').click();

			}, 100
		);

	});

	// Resource Center
	$('.Shortcodes-hamburger').click(function () {
		$('.Shortcodes-mobile-nav-resource').css("display", "initial");
		$('body').css("overflow", "hidden");
	});

	$('.Shortcodes-close-icon').click(function () {
		$('.Shortcodes-mobile-nav-resource').css("display", "none");
		$('body').css("overflow", "initial");
	});

	$('.Shortcodes-show-results').click(function () {
		$('.Shortcodes-mobile-nav-resource').css("display", "none");
		$('body').css("overflow", "initial");
	});

	$('[data-sf-field-type="taxonomy"]').click(function () {
		this.classList.toggle('active');
	});
});
